import Markdown from "markdown-to-jsx";
import { FC } from "react";

import { SkuImage } from "@/components/skus/sku-image";
import { SKU } from "@/data/types";
import { preserveLineBreaks } from "@/lib/utils";

type Props = {
  sku: SKU;
};

export const ProductPreview: FC<Props> = ({ sku }) => (
  <div className="pl-12">
    <div className="w-[375px] rounded-4xl bg-secondary overflow-y-scroll shadow-[0px_3px_15px_0px_hsla(0,0%,0%,0.05)] p-6 space-y-4 border aspect-9/16">
      <p className="uppercase text-xl">{sku.name}</p>
      <SkuImage
        src={sku.image_url}
        alt={sku.name}
        className="bg-gray-300 rounded-xl"
      />

      {sku.description && (
        <div className="text-sm text-gray-900 prose max-w-none break-words">
          <Markdown>{preserveLineBreaks(sku.description)}</Markdown>
        </div>
      )}
    </div>
  </div>
);
